import React from 'react';
import './PrePaidDiscountParkingCSS.css';
import moment from 'moment';
import PrePaySelectorComponent from '../../homepage/PrePaySelectorComponent'
import { getListItem, createElementFromHTML, getListItemsByName } from '../../../../helpers/helpers'
import Card from "../../../common/card/card";
export default class ParkingPageComponent extends React.Component {
    constructor(props) {
        super(props);
        const isSpanish = window.location.pathname.slice(0, 4) === '/es' || window.location.pathname.slice(0, 4) === '/es/';
        
        this.state = {
            isSpanish,
            hidXID: '255',
            dpnLocations: 'PHX',
            txtCheckInDt: '',
            dpnCheckInTime: '',
            txtCheckOutDt: '',
            dpnCheckOutTime: '',
            startDate: null,
            endDate: null,
            times: this.getTimes(),
            r: []
        };


        fetch(`/api/default/contentitems?$filter=Id%20eq%20e578ffa0-0c49-6a75-a385-ff1400f4265d&sf_culture=${isSpanish ? 'es' : 'en'}`)
            .then(response => response.json())
            .then(value => value.value[0])
            .then(value => value.Content)
            .then(content => this.setState(Object.assign(this.state, { content })));
        //f1bb00a1-0c49-6a75-a385-ff1400f4265d
        //929301a1-0c49-6a75-a385-ff1400f4265d
        //getListItemsByName('PHX Discount Parking Content',isSpanish)
        getListItem('929301a1-0c49-6a75-a385-ff1400f4265d',isSpanish)
            .then(items => {
                console.log(items.value)
                return items.value;
            })
            .then(items => items.map(i => {
                const tempElements = createElementFromHTML(i.Content);
                return { elem: tempElements, title: i.Title }
            })).then(items => {
                return items.map(t => {
                    let r = [];
                    const length = t.elem.length;
                    let p = [];
                    for (let i = 0; i < length; i++) {
                        let inElem = t.elem[i];
                        if (i === length - 1) {
                            let a = this.findAchor(inElem);
                            if (a === null) {
                                p.push(inElem.outerHTML)
                            };

                            r.push(<Card className={"col-12 p-1"} title={t.title} key={t.title}
                                buttonText={a === null ? a : a.innerText}
                                onClickHandler={() => a === null ? null : window.location = a.href}>
                                {p.map((inText, idx) => <div key={t.title + idx}
                                    dangerouslySetInnerHTML={{ __html: inText }} />)}
                            </Card>)

                        } else {
                            p.push(inElem.outerHTML);
                        }
                    }

                    return r;
                });

            }).then(e => this.setState(Object.assign(this.state, { r: e })))
    }

    findAchor = (elem) => {
        if (elem.childNodes.length === 0) {
            return null
        }
        if (elem.childNodes[0].nodeName.toUpperCase() === 'A') {
            return elem.childNodes[0]
        }
        return this.findAchor(elem.childNodes[0]);
    };

    handleStartDateChange = (date) => {
        let m = moment(date);
        this.setState(Object.assign(this.state, {
            startDate: date,
            arrivalError: null,
            txtCheckInDt: m.format('MM/DD/YYYY'),
        }))
    };

    handleStartTimeChange = (time) => {
        console.log(time.target.value);
        this.setState(Object.assign(this.state, {
            arrivalTimeError: undefined,
            dpnCheckInTime: time.target.value
        }))
    };

    handleEndDateChange = (date) => {

        let m = moment(date);
        this.setState(Object.assign(this.state, {
            endDate: date,
            departureError: null,
            txtCheckOutDt: m.format('MM/DD/YYYY'),
            dpnCheckOutTime: m.format('HH:mm')
        }))
    };

    handleEndTimeChange = (time) => {
        console.log(time.target.value);
        this.setState(Object.assign(this.state, {
            departureTimeError: undefined,
            dpnCheckOutTime: time.target.value
        }))
    };

    checkAvailability = () => {

        this.r.submit();
    };

    getTimes = () => {
        let m = moment();
        console.log(m);
        const interval = 15;
        const period = 'minutes';
        const periodsInADay = moment.duration(1, 'day').as(period);
        const timeLabels = [];
        const startTimeMoment = moment("00:00", 'hh:mm');
        for (let i = 0; i <= periodsInADay - 1; i += interval) {
            startTimeMoment.add(i === 0 ? 0 : interval, period);
            timeLabels.push(startTimeMoment.format('h:mm A'));
        }

        return timeLabels;
    };

    render() {
        return (
            <div className="row">
                <div className="col-12 col-md-8">
                    <div className={"row"}>
                        <div className="col-12  px-2 mt-2">
                            <div className={"col-12 prepaid-heading p-2"}>Sky Harbor Discount Parking</div>
                        </div>
                        <div className="col-12" dangerouslySetInnerHTML={{ __html: this.state.content }}>
                        </div>
                        <div className={"col-12 p-2 mt-1"}>
                            {this.state.r === null ? null : this.state.r.map(item => item)}
                        </div>

                    </div>
                </div>
                <div className="col-12 col-md-4 text-center mt-2 " style={{ minHeight: '300px' }}>
                    <PrePaySelectorComponent />
                </div>


            </div>
        )
    }
}